<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { mapState } from "vuex";
import moment from "moment";
import Banners from "@/components/widgets/banners";
import Stat from "@/components/widgets/stat";
import ChartGraduation from "@/components/widgets/chart-graduation.vue";
import ChartBonus from "@/components/widgets/chart-bonus";
import ChartPoints from "@/components/widgets/chart-points";
import ChartOrders from "@/components/widgets/chart-orders";
import Binary from "@/components/binary.vue";

import { VueSvgGauge } from "vue-svg-gauge";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Banners,
    Stat,
    ChartGraduation,
    ChartBonus,
    ChartPoints,
    ChartOrders,
    Binary,
    VueSvgGauge,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      month_year: moment().format("MM/YY"),

      monthly: "inactive",

      total: {
        prediction: "R$ -,--",
        bonus: "R$ -,--",
        balance: "R$ -,--",
      },

      graduation: {
        id: null,
        name: '-',
        image: null
      },

      premiations: null,

      statData: null,
      wallets: null,

      cart: {
        items: {
          loading: true,
          total: 0,
          list: null
        },
        points: {
          binary: 0,
          unilevel: 0,
          graduation: 0,
        },
        subtotal: '0.00',
        sale: '0.00',
        shipping: {
          method: '-',
          value: '-',
        },
        total: '0.00'
      },

      referral: {
        sponsored: process.env.VUE_APP_URL_PAINEL + this.$store.state.account.user.username,
        ecommerce: 'https://' + this.$store.state.account.user.username + '.' + process.env.VUE_APP_URL_ECOMMERCE
      }
    };
  },
  methods: {
    getMonthly() {
      api.get("reports/monthly").then((response) => {
        this.monthly = response.data.status;
        this.getStatData();
      });
    },
    getGraduation() {
      api
        .get('reports/graduation')
        .then(response => {
          if (response.data.status == 'success') {
            this.graduation.id = response.data.current.id
            this.graduation.name = response.data.current.name
            this.graduation.image = response.data.current.image
          }
        })
    },
    getPremiations() {
      api.get("reports/premiations").then((response) => {
        if (response.data.status === "success") {
          this.premiations = response.data;
        }
      });
    },
    getTotalPrediction() {
      api.get("reports/bonus/prediction").then((response) => {
        if (response.data.status == "success") {
          this.total.prediction = this.$options.filters.currency(
            response.data.total
          );
          this.getStatData();
        }
      });
    },
    getTotalBonus() {
      api
        .get('reports/bonus/total')
        .then(response => {
          if (response.data.status == 'success') {
            this.total.bonus = this.$options.filters.currency(response.data.total)
            this.getStatData();
          }
        })
    },
    getTotalBalance() {
      api
        .get('wallet/balance/network')
        .then(response => {
          if (response.data.status == 'success') {
            this.total.balance = this.$options.filters.currency(response.data.balance)
            this.getStatData();
          }
        })
    },
    getStatData() {
      this.statData = [
        {
          type: "line",
          title: "Plano",
          value: this.account.user.package.name,
          icon: "bx-package"
        },
        {
          type: "line",
          icon: "bx-time-five",
          title: "Status",
          value: this.monthly,
          month: true,
        },
        {
          type: "line",
          icon: "bxs-graduation",
          title: "Graduação",
          value: this.graduation.name,
        },
        {
          type: "line",
          icon: "bx-line-chart",
          title: "Previsão de Bônus",
          value: this.total.prediction,
          month: true,
        },
        {
          type: "line",
          icon: "bx-dollar",
          title: "Total de Bônus",
          value: this.total.bonus,
        },
        {
          type: "line",
          icon: "bx-wallet",
          title: "Saldo Disponível",
          value: this.total.balance,
        }
      ]
    },
    getCart() {
      if (!localStorage.cart) {
        api
          .get('store/cart')
          .then(response => {
            if (response.data.status == 'success') {
              this.setStorage(response.data)
            }
          })
          .catch(error => {
            this.cart.errored = error
          })
      } else {
        this.cart = JSON.parse(localStorage.cart)
      }
    },
    setStorage(data) {
      this.cart.items.total = data.items.total
      this.cart.items.list = data.items.list
      this.cart.subtotal = data.subtotal
      this.cart.sale = data.sale
      this.cart.shipping = data.shipping
      this.cart.total = data.total

      localStorage.cart = JSON.stringify(this.cart)
    },
  },
  mounted() {
    this.getMonthly()
    this.getGraduation()
    this.getPremiations()
    this.getTotalPrediction()
    this.getTotalBonus()
    this.getTotalBalance()
    this.getStatData()
    this.getCart()
  }
};
</script>

<template>
  <Layout>
    <router-link v-if="cart.items.total > 0" to="/store/cart" class="text-dark">
      <div class="card">
        <div class="card-body bg-soft-warning rounded p-0">
          <div class="d-flex align-items-center">
            <img class="rounded-circle header-profile-user m-2 mx-2" :src="cart.items.list[Object.keys(cart.items.list)[0]].image" width="30px" height="30px">
            <div class="py-3">Você deixou alguns produtos em seu carrinho, clique aqui para finalizar o seu pedido!</div>
          </div>
        </div>
      </div>
    </router-link>

    <Banners></Banners>

    <div class="card mb-2">
      <div class="card-body p-1 d-flex justify-content-between align-items-center">
        <div class="mr-2">
          <div class="bg-light rounded p-2">
            <i class="bx bx-link-alt font-size-24 align-middle"></i>
          </div>
        </div>
        <h5 class="flex-fill m-0 align-items-center font-size-16">
          Link de indicação
        </h5>
        <div class="d-flex align-items-center">
          <div class="ml-1">
            <ShareNetwork network="whatsapp" url="" :title="referral.sponsored">
              <div class="bg-light rounded p-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #322F4F;">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263">
                  </path>
                </svg>
              </div>
            </ShareNetwork>
          </div>
          <div class="ml-1">
            <button class="btn btn-link p-0 m-0" v-clipboard:copy="referral.sponsored
              " v-on:click="$toast.success('Copiado!');">
              <div class="bg-light rounded p-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #322F4F;">
                  <path
                    d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z">
                  </path>
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body p-1 d-flex justify-content-between align-items-center">
        <div class="mr-2">
          <div class="bg-light rounded p-2">
            <i class="bx bx-link-alt font-size-24 align-middle"></i>
          </div>
        </div>
        <h5 class="flex-fill m-0 align-items-center font-size-16">
          Link do e-commerce
        </h5>
        <div class="d-flex align-items-center">
          <div class="ml-1">
            <ShareNetwork network="whatsapp" url="" :title="referral.ecommerce">
              <div class="bg-light rounded p-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #322F4F;">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263">
                  </path>
                </svg>
              </div>
            </ShareNetwork>
          </div>
          <div class="ml-1">
            <button class="btn btn-link p-0 m-0" v-clipboard:copy="referral.ecommerce
              " v-on:click="$toast.success('Copiado!');">
              <div class="bg-light rounded p-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #322F4F;">
                  <path
                    d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z">
                  </path>
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div v-for="(stat, index) of statData" :key="index" class="col-md-6 col-lg-4">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" :month="stat.month" />
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-3">
        <Binary />
      </div>
    </div>

    <div v-if="premiations && premiations.current" class="premiations d-flex" :style="{ backgroundImage: 'url(' + require('@/assets/images/premiations/' + premiations.current.image) + ')' }">
      <div class="info align-self-center">
        <div class="gauge">
          <vue-svg-gauge class="chart" :start-angle="-110" :end-angle="110" :value="parseFloat(premiations.current.percent)" :separator-step="0" :min="Number(0)" :max="Number(100)" gauge-color="#000"
            :scale-interval="0" />
          <div class="points text-white">
            <h1 class="mb-0 text-white">{{ premiations.total | points }}</h1>
            <p>PONTOS<br />ACUMULADOS</p>
          </div>
        </div>
        <div class="bar">
          <b-progress style="border-radius: 3px;" :value="Number(premiations.current.percent)" variant="white" height="15px"></b-progress>
          <div class="points text-white d-flex justify-content-center align-items-center flex-gap-5">
            <h4 class="mb-0 text-white">{{ premiations.total | points }}</h4>
            <p class="mb-0">PONTOS ACUMULADOS</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-6">
        <fieldset class="card-h-fix">
          <legend>
            Graduação <sup class="font-weight-light">{{ month_year }}</sup>
          </legend>
          <div class="d-flex justify-content-center card-h-fix">
            <ChartGraduation />
          </div>
        </fieldset>
      </div>
      <div class="col-md-12 col-lg-6">
        <fieldset class="card-h-fix">
          <legend>
            Bonificações <sup class="font-weight-light">{{ month_year }}</sup>
          </legend>
          <div class="d-flex justify-content-center card-h-fix">
            <ChartBonus />
          </div>
        </fieldset>
      </div>
      <div class="col-md-12 col-lg-6">
        <fieldset class="card-h-fix">
          <legend>
            Pontuações <sup class="font-weight-light">{{ month_year }}</sup>
          </legend>
          <div class="d-flex justify-content-center card-h-fix">
            <ChartPoints />
          </div>
        </fieldset>
      </div>
      <div class="col-md-12 col-lg-6">
        <fieldset class="card-h-fix">
          <legend>
            Pedidos <sup class="font-weight-light">{{ month_year }}</sup>
          </legend>
          <div class="d-flex justify-content-center card-h-fix">
            <ChartOrders />
          </div>
        </fieldset>
      </div>
    </div>
  </Layout>
</template>

<style>
.premiations {
  justify-content: end;
  position: relative;
  background-color: #999;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 5px;
  margin-bottom: 30px;
  width: 100%;
  height: 400px;
}

.premiations .info {
  position: absolute;
  margin-right: 50px;
}

.premiations .info .gauge .chart {
  height: 220px;
}

.premiations .info .gauge .points {
  position: absolute;
  top: 120px;
  width: 100%;
  text-align: center;
}

.premiations .info .points p {
  line-height: 13px;
}

.premiations .gauge {
  display: block;
}

.premiations .bar {
  display: none;
}

@media (max-width: 575px) {
  .premiations {
    background-size: cover;
    background-position: left;
    height: 220px;
    justify-content: center;
  }

  .premiations .info {
    bottom: auto;
    margin-right: 0;
    justify-content: center !important;
  }

  .premiations .info .chart {
    height: 190px;
  }

  .premiations .gauge {
    display: none;
  }

  .premiations .bar {
    display: inline-block;
    margin-top: 170px;
    width: 300px !important;
  }
}
</style>